export const contentTableConfig = {
  title: '通话统计查询',
  propList: [
    { prop: 'accountName', label: '名称', minWidth: '120' },
    { prop: 'accountId', label: '账户ID', minWidth: '80' },
    { prop: 'usedBy', label: '使用人', minWidth: '80' },
    {
      prop: 'parentDeptName',
      label: '组',
      minWidth: '120'
    },
    {
      prop: 'deptName',
      label: '岗位',
      minWidth: '120'
    },
    {
      prop: 'corpName',
      label: '企业号',
      minWidth: '120'
    },
    {
      prop: 'beginDate',
      label: '开始日期',
      minWidth: '120'
    },
    {
      prop: 'endDate',
      label: '结束日期',
      minWidth: '120'
    },
    {
      prop: 'duration',
      label: '通话总时长',
      minWidth: '120',
      slotName: 'duration',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.duration) -
          parseFloat(b.duration)
        )
      },
    },
    {
      prop: 'callCounts',
      label: '通话量',
      minWidth: '120',
      sortable: true
    },
    {
      label: '通话详情',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
